/// <amd-module name="Pipeline/Analytics/PipelineOutcome/FailedRunsCard/Common/StackedBarChartDataSelector" />
import { getPercentage } from "Analytics/Shared/Utils/Number";
import { getStackedBarChartData } from "Pipeline/Analytics/Common/ChartHelper/StackedBarChartDataSelector";
import { colors } from "Pipeline/Analytics/Common/Constants";
import { maxItemsToShowInCharts } from "Pipeline/Analytics/Common/Constants";
import * as TelemetryConstants from "Pipeline/Analytics/Common/Telemetry/TelemetryConstants";
import { IAnalyticsChartProps } from "Pipeline/Analytics/Common/Types";
import { ITopFailingTasks } from "Pipeline/Analytics/PipelineOutcome/Common/Types";
import * as Resources from "Pipeline/Analytics/PipelineOutcome/FailedRunsCard/Resources";
import { ChartProps } from "VSS/Features/Charts/Contracts";
import { IVssPageContext } from "VSS/Platform/Context";

export function getStackedBarChartProps(pageContext: IVssPageContext, data: ITopFailingTasks): ChartProps {
    // Sort the tasks based on total failures and just consider top 'taskLimit' tasks
    data.failingTasksData = data.failingTasksData.sort((a, b) => b.failedCount - a.failedCount).slice(0, maxItemsToShowInCharts);
    let i = 0;
    const series = data.failingTasksData.map(task => {
        return {
            name: task.taskName,
            data: [getPercentage(data.failedCount, task.failedCount)],
            color: colors[i++]
        };
    });

    const chartData = {
        title: Resources.TaskFailureTrendChartTitle,
        series: series,
        telemetryArea: TelemetryConstants.feature_PipelineAnalyticsTasksFailedTrendChart
    } as IAnalyticsChartProps;
    return getStackedBarChartData(pageContext, chartData);
}
